import type { RouteLocationNormalized } from 'vue-router'

// Nuxt only reloads on chunk errors raised during a route navigation. A dynamic import that
// fails outside of it (app init, lazy components) leaves a broken page, typically on iOS
// Safari after a network blip or once a deploy has removed the old build's chunks.
// reloadNuxtApp() remembers the reloaded path for 10s, so a persistent failure cannot loop.
export default defineNuxtPlugin((nuxtApp) => {
  let navigatingTo: RouteLocationNormalized | null = null

  addRouteMiddleware((to) => {
    navigatingTo = to
  })

  nuxtApp.hook('app:chunkError', () => {
    const route = navigatingTo ?? nuxtApp._route
    reloadNuxtApp({ path: route.fullPath, persistState: true })
  })
})
